import React, { useMemo, useState } from 'react'
import { useAtom } from 'jotai'
import { useDispatch, useSelector } from 'react-redux'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material'
import * as mdt from '../../../src/components/common/modaltypes'
import * as iid from '../common/bookingElementId'
import { alertAtom } from '../common/jotaiState/globalStateAtoms'
import { activeClassForLr, focusElemnt, isValidGSTNo, navigation2 } from '../common/helper'
import { modeAllPayments, paymentModesWithAll } from '../common/paymentsMode'
import { consignmentTypeAll, paymentTypeColor } from '../common/constants'
import Modal from '../common/modal'
import { Item } from '../common/snippets'
import DropDownOA from '../common/dropDownOA'
import Lineinput from '../common/lineinput'
import { companySettingsAtom } from '../common/jotaiState/commonStateAtoms'
import moment from 'moment'
import { getLrStatus, updateModal, updateSearchBy } from '../../store/common/common_action'
import { getsearchLrDataAtom, lrSearchColumnsAtom, lrSearchModeAtom, searchLrDataAtom, selectLrAtom, showHeaderAtom, showManageColumnAtom } from '../common/jotaiState/lrSearchAtoms'
import { useEffect } from 'react'
import { Apps } from '@mui/icons-material'
import ManageColumns from '../common/ManageColumnsUI'
import { RAJESH_TRANSPORT } from '../../helper/companyIdhardcode'
const searchBy = [
  { id: 1, name: 'LR Number' },
  { id: 2, name: 'Challan Number' },
  { id: 3, name: 'Manual LR Number' },
  { id: 4, name: 'Sender Mobile Number' },
  { id: 5, name: 'Receiver Mobile Number' },
  { id: 8, name: 'GST Invoice Number' },
]


export const SearchLrPopupUI = () => {
  const theme = useTheme()
  const common = useSelector((state) => state?.common)
  const dispatch = useDispatch()
  const { loginData, cnsgnmntTypes } = common
  const [companySettings] = useAtom(companySettingsAtom)
  const { IsShowAllLROption = 0 } = companySettings
  const { UseToPayAsCOD = 0 } = companySettings
  const [lrNumber, setLrNumber] = useState('')
  const [filtered, setFiltered] = useState([])
  const [, setAlert] = useAtom(alertAtom)
  const [mode, SetMode] = useAtom(lrSearchModeAtom)
  const [selectLr, setSelectLr] = useAtom(selectLrAtom)
  const [showHeader, setShowHeader] = useAtom(showHeaderAtom)
  const [apiCall, setApiCall] = useState(false)
  const [selPaymentTpe, setSelPaymentType] = useState(modeAllPayments)
  const [searchAllLr, setSearchLR] = useState(false)
  const [consignmentType, setConsignmentType] = useState({})
  const [searchLrData,setSearchLrData] = useAtom(searchLrDataAtom)
  const [,fetchSearchLrData] = useAtom(getsearchLrDataAtom)
  const [columns, setColumns] = useAtom(lrSearchColumnsAtom);
  const [showManageColumn,setShowManageColumn] = useAtom(showManageColumnAtom)
  const [searchData, setSearchData] = useState({})
  const { tableColumns, colSet } = useMemo(() => {
    const tableColumns = columns.filter((col) => col.isSelected)
    const colSet = new Set(tableColumns.map((col) => col.id))
    return {
      tableColumns,
      colSet,
    }
  }, [columns])
  
  const handleSaveColumns = (items) => {
    setColumns(items)
    setShowManageColumn(false)
  }
  const handleAlert = (msg = false, nextId = '') => {
    setAlert({ show: true, msg, nextId })
  }
  const handleChange = (e) => {
    setLrNumber(e.target.value)
  }
  const SelectLrForTracking = () => {
    setSearchLrData([])
    setLrNumber('')
    SetMode(1)
    const data = {
      intCompanyID: loginData?.intCompanyID,
      intBranchID: loginData.intBranchID,
      intUserID: loginData.intUserID,
      strLRNO: selectLr?.LRNo,
      BookingID: selectLr?.BookingID,
    }
    dispatch(getLrStatus(data))
    dispatch(updateModal(true, mdt.lrTrackingPopup))
  }
  useEffect(() => {
    const filterData = searchLrData.filter((row) => {
      return Object.entries(searchData).every(([key, value]) => {
        if (value === '') return true
        const rowValue = row?.[key]
        return rowValue != null && rowValue.toString().toLowerCase().includes(value.toString().toLowerCase())
      })
    })
    setFiltered(filterData)
  }, [searchData, searchLrData])
  
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }
  const Search_Lr_Click = () => {
    setSelectLr('')
    if (lrNumber == '') {
      handleAlert('Select LRNO')
    } else {
      let strlrno
      let isFullLr
      setShowHeader(false)
      setApiCall(true)
      //0 will only appends if lrNumber length is less than 7 and it doesn't include any / or \
      isFullLr = lrNumber.includes('\\') || lrNumber.includes('/')
      if (lrNumber.length < 7 && mode === 1 && !isFullLr) {
        strlrno = '0000000' + lrNumber
        strlrno = strlrno.substring(strlrno.length - 7)
      } else {
        strlrno = lrNumber
      }
      const { IsBranchAdmin, IsMTPLAdmin, IsAdmin,intCompanyID } = loginData
      const obj = {
        intCompanyID: loginData.intCompanyID,
        intBranchID: loginData.intBranchID,
        intUserID: loginData.intUserID,
        intPaytypeID: selPaymentTpe.typeId,
        intConsignmentSubTypeID: consignmentType?.ConsignmentSubTypeID || 0,
        intMode: (strlrno.includes('/') || strlrno.includes('\\')) && mode === 1 ? 7 : mode,
        strSearchValue: strlrno,
        IsAllLRSearchData: searchAllLr ? 1 : 0,
      }
      const filterOwnLR = intCompanyID === RAJESH_TRANSPORT && !(IsBranchAdmin || IsMTPLAdmin || IsAdmin)
      fetchSearchLrData(obj,UseToPayAsCOD,filterOwnLR)
    }
  }
  const handleCancel = () => {
    setApiCall(false)
    setShowHeader(true)
    setSearchLrData([])
    dispatch(updateModal())
    SetMode(1)
  }
  useEffect(() => {
    if (searchLrData?.length > 0) {
      setSelectLr(searchLrData[0])
      setTimeout(() => {
        focusElemnt('checkbox_' + searchLrData[0].BookingID)
      }, 30)
    }
  }, [searchLrData])
  const modeClose = () => dispatch(updateModal())
  return (
    <>
      <Modal
        closeId="closeSearchPopup"
        headTxt={`List of LR (WayBill)`}
        width={'95%'}
        updateModal={modeClose}
        onCloseCallback={handleCancel}
      >
        <Stack sx={{ minHeight: 100, minWidth: 650, marginTop: '8px' }}>
          <Box
            key={`for_otp_lnIp_`}
            className='lr-container'
            sx={{
              width: '99%',
              display: 'inline-flex',
              padding: '0% 0px',
            }}
          >
            <Item sx={{ width: '25%' }} className='lr-input-field'>
              <DropDownOA
                id={iid.consignmentType}
                data={[consignmentTypeAll, ...cnsgnmntTypes] || []}
                width="100%"
                searchPlaceholder={'Search Consignment Type'}
                label={`Select Consignment Type`}
                isObjArr={true}
                dataKey={`SubType`}
                idKey={`ConsignmentSubTypeID`}
                tabIndex="5"
                defaultvalue={consignmentTypeAll.SubType}
                nextId={iid.selectPayment}
                prevId={'closeSearchPopup'}
                onSelect={(val) => setConsignmentType(val)}
              />
            </Item>

            <Item sx={{ width: '25%' }} className='lr-input-field'>
              <DropDownOA
                data={paymentModesWithAll || []}
                width="100%"
                searchPlaceholder={'Search Payment Type'}
                label={`Select Payment Type`}
                isObjArr={true}
                dataKey={`name`}
                idKey={`typeId`}
                tabIndex="5"
                id={iid.selectPayment}
                defaultvalue={modeAllPayments.name}
                nextId={iid.selectSearchBy}
                prevId={iid.consignmentType}
                onSelect={(val) => {
                  setSelPaymentType(val)
                }}
              />
            </Item>
            <Item sx={{ width: '25%' }} className='lr-input-field' >
              <DropDownOA
                defaultvalue={searchBy?.[0]?.name}
                data={searchBy || []}
                width="100%"
                // searchPlaceholder={'Search By'}
                label={`Select Option Search By`}
                isObjArr={true}
                dataKey={`name`}
                idKey={`id`}
                tabIndex="5"
                id={iid.selectSearchBy}
                nextId={iid.selectInput}
                prevId={iid.selectPayment}
                onSelect={(e) => {
                  SetMode(e.id)
                  dispatch(updateSearchBy(e))
                }}
              />
            </Item>
            <Item sx={{ width: '25%' }} className='lr-input-field'>
              <div className={'input--wrapper'} style={{ marginBottom: '0px' }}>
                <Lineinput
                  id={iid.selectInput}
                  type="text"
                  name="E-Way bill_no"
                  label={common?.selSearchBy?.name === 'Paid' ? 'LR Number' : common?.selSearchBy?.name}
                  searchPlaceholder={'LR Number'}
                  value={lrNumber}
                  disabled={false}
                  autoFocus={true}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(e) => navigation2(e, iid.searchLrButton, iid.selectSearchBy)}
                />
              </div>
            </Item>
            {IsShowAllLROption ? (
              <Item className='lr-input-field'>
                <div className="input--wrapper small_space">
                  <FormControlLabel
                    sx={{ whiteSpace: 'nowrap' }}
                    control={
                      <Checkbox
                        id="exempted-checkbox"
                        checked={searchAllLr}
                        onChange={() => setSearchLR((a) => !a)}
                        onKeyDown={(e) => {}}
                      />
                    }
                    label="Show All LR"
                  />
                </div>
              </Item>
            ) : (
              ''
            )}
            <div className="input--wrapper small_space" style={{ padding: '8px' }}>
              <Button
                id={iid.searchLrButton}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', whiteSpace: 'nowrap' }}
                onClick={Search_Lr_Click}
                //  onKeyDown={(e) => {}}
              >
                SEARCH LR
              </Button>
            </div>
          </Box>
          <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <TableContainer
              className="lr-popup-table lrModel"
              component={Paper}
              style={{
                height: '400px',
                display: showHeader ? 'none' : '',
                //display: !apiCall && searchLrData?.length !== 0 ? 'none' : '',
              }}
            >
              <Table
                // style={{ visibility: searchLrData?.length > 0 ? '' : 'hidden' }}
                className="table1"
                size="small"
                aria-label="a dense table"
              >
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow style={{ background: `#e5f3fa` }}>
                    {tableColumns.map((a, i) => (
                      <TableCell key={'ered3' + i} style={{ fontSize: '13px',padding: '6px' }}>
                        {a.header}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell className="checkbox-ctrl">{/* <input type="radio" /> */}</TableCell>
                    {tableColumns.slice(1).map((item) => (
                      <TableCell key={'eredsii3' + item.id} style={{padding: '6px' }}>
                        <div className="filter-input" style={{ fontSize: '13px' }}>
                          <input
                            className="field"
                            name="searchInput"
                            placeholder={item.header}
                            onChange={(e) => handleSearchData(e, item.id)}
                            style={{ width: '100px' }}
                          />
                          <FilterAltIcon />
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody className="filter-data-row">
                  {filtered?.map((item, index) => (
                    <TableRow
                      onClick={() => setSelectLr(item)}
                      key={index+`${item.LRNo}effww3`}
                      style={{ backgroundColor: item.LRNo == selectLr?.LRNo ? '#e5f3fa' : '' }}
                    >
                      <TableCell className="checkbox-ctrl">
                        <input
                          type="radio"
                          id={`checkbox_${item.BookingID}`}
                          checked={item.BookingID === selectLr?.BookingID}
                          onChange={() => {}}
                          name="record"
                          onKeyDown={(e) => navigation2(e, iid.selectLrTracking, `checkbox_${item.BookingID}`)}
                        />
                      </TableCell>
                      {colSet.has('LRNo') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.LRNo}>
                            {item.LRNo}
                          </span>
                        </TableCell>
                      )}

                      {colSet.has('FormattedLRNO') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.FormattedLRNO}>
                            {item.FormattedLRNO}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('ManualLRNo') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.ManualLRNo}>
                            {item.ManualLRNo}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('BookingDateTime') && (
                        <TableCell>
                          <span
                            style={{ fontSize: '13px' }}
                            title={moment(item.BookingDateTime, 'DD-M-YYYY hh:mm A').format('DD-MMM-YY HH:mm')}
                          >
                            {moment(item.BookingDateTime, 'DD-M-YYYY hh:mm A').format('DD-MMM-YY HH:mm')}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('Status') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.Status}>
                            {item.Status}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('VoucherNo') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.VoucherNo}>
                            {item.VoucherNo}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('PaymentType') && (
                        <TableCell>
                          <span className={activeClassForLr(item.PaymentType)} title={item.PaymentType}>
                            {item.PaymentType}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('Sender') && (
                        <TableCell>
                          <span style={{ fontSize: '13px', width: '90px' }} title={item.Sender}>
                            {item.Sender}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('SenderMobileNo') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.SenderMobileNo}>
                            {item.SenderMobileNo}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('RecName') && (
                        <TableCell>
                          <span style={{ fontSize: '13px', width: '90px' }} title={item.RecName}>
                            {item.RecName}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('RecMobileNo') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.RecMobileNo}>
                            {item.RecMobileNo}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('BookingBranchName') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.BookingBranchName}>
                            {item.BookingBranchName}
                          </span>
                        </TableCell>
                      )}
                      {colSet.has('DestinationBranchName') && (
                        <TableCell>
                          <span style={{ fontSize: '13px' }} title={item.DestinationBranchName}>
                            {item.DestinationBranchName}
                          </span>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {apiCall && searchLrData?.length === 0 ? (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', color: 'red' }}>
                  <span>No results found. Please refine your search parameters and search again.</span>
                </div>
              ) : (
                ''
              )}
            </TableContainer>
          </div>
        </Stack>
        <Stack>
          <div className="modal-btn-grp" style={{ display: searchLrData?.length > 0 ? '' : 'none', justifyContent: 'space-between' }}>
            <span style={{ marginLeft: '10px' }}>
              <Box
                style={{
                  height: '32px',
                  display: 'flex',
                  padding: '8px 12px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '6px',
                  borderRadius: '5px',
                  border: '2px solid ' + theme.palette.secondary.main,
                }}
                id="lrSearchManageColumn"
                tabIndex={0}
                onClick={() => setShowManageColumn(true)}
              >
                <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                  <Apps color='secondary' />
                </span>
                <span tabIndex={0} style={{ fontWeight: 'bold', color: theme.palette.secondary.main }}>
                  MANAGE COLUMNS
                </span>
              </Box>
            </span>
            <span style={{ display: 'flex' }}>
              {paymentTypeColor.map((val, i) => {
                return (
                  <React.Fragment key={i+val.value}>
                    <span
                      style={{ marginLeft: '10px', backgroundColor: val.color, width: '13px', height: '13px', borderRadius: '50%' }}
                    ></span>
                    <span style={{ padding: '0px 7px', fontSize: '12px' }}>{val.value}</span>
                  </React.Fragment>
                )
              })}
            </span>
            <div className="input--wrapper small_space">
              <Button
                className="cancel-btn"
                variant="outlined"
                color="error"
                style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '1.3rem' }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                id={iid.selectLrTracking}
                className="select-lr-btn"
                variant="contained"
                color="error"
                style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', borderColor: 'white' }}
                onClick={SelectLrForTracking}
              >
                Select LR For Tracking
              </Button>
            </div>
          </div>
        </Stack>
      </Modal>
      {showManageColumn && <ManageColumns headers={columns} onSave={handleSaveColumns} updateModal={setShowManageColumn} />}
    </>
  )
}
